import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PrimeVue from "primevue/config";
import "primevue/resources/primevue.min.css"      
import "primeicons/primeicons.css"
import 'prismjs'
import 'prismjs/themes/prism.css'
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-c'
const app = createApp(App);
app.use(PrimeVue);

createApp(App).use(store).use(router).mount("#app");
